import React from 'react';

import { $config } from '@client/core/atoms/config.js';

import { ObjectExplorer } from '../ObjectExplorer/index.js';

export function DataTab() {
  const config = $config.get();
  return (
    <div className="ml-8 mr-8 flex flex-col gap-4">
      <ObjectExplorer data={config} />
    </div>
  );
}

DataTab.friendlyName = 'Data' as const;
